import { menus } from "../services/Menus.Service";

// Detail routes do not always share the exact path of their sidebar entry.
// Keep those aliases here so the route guard stays role-agnostic.
const menuRouteAliases = {
  "/user": "/users",
  "/permissions": "/roles",
};

export const getMenuOptions = () =>
  menus.flatMap((menu) =>
    menu.items.map((item) => ({
      value: item.path,
      label: `${menu.name} > ${item.name}`,
      name: item.name,
      path: item.path,
      parent: menu.name,
    }))
  );

export const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user") || "{}");
  } catch {
    return {};
  }
};

export const getAllowedMenuPaths = (user = getStoredUser()) => {
  const roleMenus = user?.roleDetails?.menus || user?.role?.menus || user?.allowedMenus;
  if (!Array.isArray(roleMenus)) return [];
  return roleMenus
    .map((item) => (typeof item === "string" ? item : item?.path || item?.value))
    .filter(Boolean);
};

export const isMenuRestricted = (user = getStoredUser()) =>
  !user?.isSuperAdmin && Boolean(user?.isMenuRestricted || user?.roleDetails?.isMenuRestricted);

export const getAccessibleMenus = (user = getStoredUser()) => {
  if (!isMenuRestricted(user)) return menus;
  const allowed = new Set(getAllowedMenuPaths(user));
  return menus
    .map((menu) => ({
      ...menu,
      items: menu.items.filter((item) => allowed.has(item.path)),
    }))
    .filter((menu) => menu.items.length > 0);
};

export const getDefaultAccessiblePath = (user = getStoredUser()) => {
  if (!isMenuRestricted(user)) return "/dashboard";
  return getAccessibleMenus(user)[0]?.items[0]?.path || "/login";
};

export const canAccessPath = (path, user = getStoredUser()) => {
  if (!isMenuRestricted(user)) return true;
  if (!path || path === "/" || path === "/login") return true;
  const matchingMenu = Object.entries(menuRouteAliases).find(
    ([routePath]) => path === routePath || path.startsWith(`${routePath}/`)
  )?.[1];
  const accessiblePath = matchingMenu || path;
  return getAllowedMenuPaths(user).some(
    (allowedPath) => accessiblePath === allowedPath || accessiblePath.startsWith(`${allowedPath}/`)
  );
};
